import { TwoFASetup } from "@src/components/modules/auth/2fa-setup";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const AuthTwoFactorEnable = () => {
  return (
    <>
      <NoIndexHead />
      <TwoFASetup />
    </>
  );
};
export const Route = createFileRoute("/auth/two-factor/enable")({
  component: AuthTwoFactorEnable,
});
